<template>
  <div style="margin-top:-10px !important">
     <RecordNotFound
      v-if="status_code == 404"
      :message="status_message"
    ></RecordNotFound>
      <template v-else>
    <b-row
      class="hidden-sm-down d-print-none px-pad border-bottom justify-content-center"
      style="height:42px"
    >
      <!-- <b-col m5="1"></b-col> -->
      <b-col cols="3" md="3" xl="3" lg="3" sm="3" xs="3" class="text-left px-0">
        <!--  invoice header details -->

        <!--  invoice no and status name -->
        <h2 class="custom-page-title mb-2 mt-1">{{ list.header_details.retainer_no}}
          <small class="pl-2" v-if="$route.query.page_from=='quot_view'">
            <router-link
              :to="{ name: 'SalesView', params: { id: $route.query.id } }"
            >
              <span
                class="text-link"
                v-b-tooltip
                title="Quotation"
              >
                {{ $route.query.quot_no  }}
                <i class="la la-angle-right la-lg"></i>
              </span>
            </router-link>
          </small>
          </h2>
      </b-col>
      <b-col cols="9" md="9" xl="9" lg="9" sm="9" xs="9" class="text-right px-0">
      
           <b-button variant="primary" size="sm" class="mr-2" @click="recordpayment()"   v-if="list.header_details.retainer_status_id<=5 && RoutePermission(false,'','invoice','paymentsreceived','create')">Record Payment</b-button>

        <b-button
          variant="primary"
          size="sm"
          class="mr-2"
          v-on:click.stop="callavailableinvoicemodal()"
          v-if="(list.header_details.retainer_status_id == 6 || list.header_details.retainer_status_id == 7) && RoutePermission(false,'','invoice','paymentsreceived','create')"
        >Apply To Invoice</b-button>
       
          <b-button
            variant="success"
            size="sm"
            class="mr-2"
             @click="recordrefund()"
            v-if="list.header_details.retainer_status_id != 8 &&list.header_details.retainer_status_id>=6  && RoutePermission(false,'','invoice','paymentsreceived','create')"
          >Refund</b-button>
        
       <b-button variant="primary" 
        size="sm"
        class="mr-2" 
      v-if=" RoutePermission(true,'RetainerInvoiceCreate','','','')"
        :to="{ name: 'RetainerInvoiceCreate', query:{page_from:'view',old_id:$route.params.id}}">
        New Customer Deposit
        </b-button>

        <b-button-group variant="light" class="ml-2">
            
          <b-button
            v-if=" RoutePermission(false,'','invoice','paymentsreceived','update')"
            size="sm"
            :to="{ name : 'RetainerInvoiceUpdate',params:{id:$route.params.id}, query: { page_from:'view'}}"
            variant="light"
          >
            <i class="la la-edit la-lg"></i>
          </b-button>
          <b-button
            variant="light"
            size="sm"
            title="email"
             @click="emailstatement()" 
            v-if="RoutePermission(false,'','invoice','paymentsreceived','email')"
          >
              <i class="la la-envelope-o la-lg"></i>
          </b-button>
          <b-button
            variant="light"
            size="sm"
            title="delete"
            v-if="parseFloat(list.header_details.received_amount) == 0 && RoutePermission(false,'','invoice','paymentsreceived','delete')"
            @click="handlingapprovingmodal({
                  content : 'Deposit will be deleted permanently. Do you want to proceed?',
                  title : 'Delete Deposit  - '+list.header_details.retainer_no,
                  module:'retainer/deleteretainer',
                  data:JSON.stringify({
                    id : $route.params.id
                  }),
                  RoutePlace:'RetainerInvoice',
                  isRoute:'true',
                  type: 'delete',
                  route_history: retainer_index_history,
                })"
          >
            <i class="glyphicon glyphicon-trash"></i>
          </b-button>
          <b-button variant="light" size="sm" title=" print" @click="handlePrint()">
            <i class="la la-print la-lg"></i>
          </b-button>
            <b-dropdown
            right
            no-caret
            variant="light"
            size="sm"
            style="height:31px !important">
             <template slot="button-content">
                <i
                  class="glyphicon glyphicon-option-vertical"
                  style="padding-bottom: 3px"
                ></i>
              </template>
              <b-dropdown-item
              v-if="RoutePermission(false,'','invoice','settings','templates')"
              @click="showFullLayout"
            >

              <i class="la la-cog la-lg mr-3"></i>Customize Print
            </b-dropdown-item>
            </b-dropdown>

          <b-button variant="light" size="sm" title="close"  :to="retainer_index_history ? retainer_index_history : { name: 'RetainerInvoice' }">
            <i class="la la-remove la-lg text-decoration-none"></i>
          </b-button>
          <!-- <a title=" print" id="print_url" size="sm" href="#" class="btn btn-light"></a> -->
        </b-button-group>
        <!-- <a title=" attach" href="#" class="btn btn-light" @click="$router.go(-1)">
            <i class="la la-remove la-lg text-decoration-none"></i>
        </a>-->
      </b-col>
    </b-row>
    <!-- 
      page first block - detailed bloc k maount
    -->

    <div class="view-block-tab" style="margin-left:-20px;margin-right:-20px;">
      <b-tabs class="customer_view_tab no-flex-grow mb-5 mt-2 border-tab">
        <!--  payment amount used in invoice tabs -->
        <b-tab title="Customer Deposit View" :title-link-class="{'d-print-none':true}" class="p-0">
          <div class="view-block d-print-none">
            <b-row class="w-100">
              <b-col cols="12" lg="12" md="12" class="py-3 px-2">
                <div class="d-flex ml-3">
                  <div class="verticalLine5 pl-3 ml-4">
                    <h6>Received Amount</h6>
                    <span>{{currency_symbol +" "+ parseFloat(list.header_details.received_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</span>
                  </div>
                  <div class="verticalLine4 pl-3 ml-4">
                    <h6>Available Amount</h6>
                    <span>{{currency_symbol +" "+ parseFloat(list.header_details.available_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</span>
                  </div>
                  <div class="verticalLine3 pl-3 ml-4">
                    <h6>Used Amount</h6>
                    <span>{{currency_symbol +" "+ parseFloat(list.header_details.used_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</span>
                  </div>
                  <div class="verticalLine5 pl-3 ml-5">
                    <h6>Refund Amount</h6>
                    <span>{{currency_symbol +" "+ parseFloat(list.header_details.refund_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</span>
                  </div>
                  <div class="ml-auto float-right" style="margin-right:-12px ">
                    <h5
                      class="text-right"
                    >{{ getPresentValue(list.retainer_status,"retainer_status_id",list.header_details.retainer_status_id,"retainer_status_name") }}</h5>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
           <StandardPrint
            class="p-4 custom-md-width"
              :printlabel="printlabel"
            :showprintlabel="showprintlabel"
            :list="list"
            :currency_symbol="currency_symbol"
            v-if="retainer_settings_details.print.templateId == 26"
            
          ></StandardPrint>
       
        </b-tab>

        <!--  payment amount used in invoice tabs -->
        <b-tab
          :title="'Payments ('+list.invoice_details_payment.length+')'"
          :title-link-class="{'d-print-none':true}"
          v-if="list.invoice_details_payment.length > 0"
          class="p-0 d-print-none"
        >
          <b-row style="max-width:1200px;" class="px-0">
            <b-col xl="12" lg="12" md="12" sm="12" xs="12">
              <table
                class="table table-bordered sales-table view-page-table last-child-border-none"
              >
                <thead>
                  <tr>
                    <th
                      class="text-left"
                      width="20%"
                      style="padding-left:22px !important"
                    >Invoice Number</th>
                    <th>Invoice Date</th>
                    <th>Invoice Amount</th>
                    <th class="text-right">Amount</th>
                    <th style="padding-right:22px !important"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in list.invoice_details_payment" :key="item.id">
                    <td
                      class="text-left"
                      width="20%"
                      style="padding-left:22px !important"
                      v-if="RoutePermission(false,'','invoice','invoice','index')"
                    >
                      <router-link
                        class="event-link theme-text-color"
                        :to="{ name : 'InvoiceView',params:{id:item.inv_hdr_id }}"
                      >{{item.inv_no }}</router-link>
                    </td>
                    <td
                      class="text-left"
                      width="20%"
                      style="padding-left:22px !important"
                      v-else
                    >{{item.inv_no }}</td>
                    <td>{{ getDateFormat(item.created_date) }}</td>
                    <td>{{ currency_symbol +" "+ parseFloat(item.grand_total).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                      class="text-right"
                    >{{ currency_symbol +" "+ parseFloat(item.retainer_applied_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td style="padding-right:22px">
                      <i
                        class="glyphicon glyphicon-trash"
                        @click="deletepaymentreason(index)"
                        v-if=" RoutePermission(false,'','invoice','paymentsreceived','delete')"
                      ></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
        </b-tab>
        <!--  payment amount refunded details -->
        <b-tab
          :title="'Refund ('+list.refund_payment_details.length+')'"
          :title-link-class="{'d-print-none':true}"
          v-if="list.refund_payment_details.length > 0"
          class="p-0 d-print-none"
        >
          <b-row style="max-width:1200px;" class="px-0">
            <b-col xl="12" lg="12" md="12" sm="12" xs="12">
              <table
                class="table table-bordered sales-table view-page-table last-child-border-none"
              >
                <thead>
                  <tr>
                    <th class="text-left" width="20%" style="padding-left:22px !important">Date</th>
                    <th>Payment Mode</th>
                    <th class="text-right">Amount Refunded</th>
                    <th style="padding-right:22px !important"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in list.refund_payment_details" :key="item.id">
                    <td class="text-left" width="20%" style="padding-left:22px !important">
                      <router-link
                        class="event-link theme-text-color"
                        :to="{ name : 'PaymentView',params:{id:item.applied_id }}"
                      >{{ getDateFormat(item.retainer_applied_date) }}</router-link>
                    </td>
                    <td>{{item.method_name}}</td>
                    <td
                      class="text-right"
                    >{{ currency_symbol +" "+ parseFloat(item.retainer_applied_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td style="padding-right:22px !important">
                      <i
                        class="glyphicon glyphicon-trash"
                        @click="deleterefund(index)"
                        v-if=" RoutePermission(false,'','invoice','paymentsreceived','delete')"
                      ></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </div>
    <!-- Sales-order print templates -->
    <FlyOver :show_full_layout="show_full_layout">
      <template slot="page-content" v-if="show_full_layout">
        <h5 class="mb-4 fw-semi-bold text-left">
         Customer Deposit Templates
          <span class="float-right pr-2">
            <i
              class="la la-close cursor_pointer fw-semi-bold pr-1"
              @click="show_full_layout = false"
            ></i>
          </span>
        </h5>
        <CustomerdepositPrint :show_full_layout="show_full_layout" :path="$route.fullPath"></CustomerdepositPrint>
      </template>
    </FlyOver>
    <DeletePaymentRecord
    @recallRecord="recallRecord()"
      v-on:setAmountDetails="updateAmountDetails($event)"
      :PaymentDeleteDetail="PaymentDeleteDetail"
    ></DeletePaymentRecord>
    <DeleteRefundRecord
    @recallRecord="recallRecord()"
      v-on:setRefundAmountDetails="updateRefundAmountDetails($event)"
      :RefundDeleteDetail="RefundDeleteDetail"
      page="retainer"
    ></DeleteRefundRecord>
    <InvoiceAvailable
    @checkCustomer="checkCustomer"
      :currency="currency_symbol"
      :field="retainerDetails"
      :title="'Apply Deposits from '+list.header_details.retainer_no"
      check="availableretainerinvoice"
      submit="updateRetainerInvoice"
      page="retainer"
    ></InvoiceAvailable>
    <GlobalModal
      :content="content"
      :module="module"
      :title="title"
      :data="globalmodaldata"
      :isRoute="isRoute"
      :RoutePlace="RoutePlace"
      :type="globalmodaltype"
       :route_history="route_history"
    />
      </template>
  </div>
</template>

<script>
import FlyOver from "@/components/Layout/Flyover";
import getPageTitle from "@/utils/get-page-title"; // to set page title
import RecordNotFound from "@/pages/Error/RecordNotFound";
import Widget from "@/components/Widget/Widget";
import { mapState, mapGetters } from "vuex"; // get data set in the state in vuex
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification
import DeletePaymentRecord from "@/components/Modal/InvoiceModal/DeletePaymentRecord"; // modal for deleting created credit used record
import DeleteRefundRecord from "@/components/Modal/InvoiceModal/DeleteRefundRecord"; // modal for deleting created credit used record
import { EventBus } from "@/event-bus.js"; // call bus event to access child component method from parent component
import CustomerdepositPrint from "@/pages/Settings/Invoice/Customerdepositprint";
import InvoiceAvailable from "@/components/Modal/InvoiceModal/InvoiceAvailable"; // credits available modal\
import $ from "jquery";
import store from "@/store/index";
import StandardPrint from "@/components/Form/RetainerInvoice/Print/Standard";
export default {
  name: "RetainerInvoiceView",
  mixins: [notificationMixin],
  data() {
    return {
      isRoute: "",
      RoutePlace: "",
      content: "",
      module: "",
      showprintlabel: false,
      printlabel: "",
      globalmodaltype: "",
      globalmodaldata: "",
      title: "",
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
      currency_symbol: "",
      retainerDetails: {},
      total_in_words: "",
      PaymentDeleteDetail: {},
      RefundDeleteDetail: {},
      show_full_layout: false,
      deletedrefundrecord: "", // to remove the item from the view page
      deletedpymntrecord: "", // to remove the item from the view page
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center" ,// notification design class
      route_history: "",
      field:{}
    };
  },
  components: {
    DeletePaymentRecord,
    Widget,
    FlyOver,
    RecordNotFound,
    DeleteRefundRecord,
    InvoiceAvailable,
    CustomerdepositPrint,
    StandardPrint
  },
  methods: {
     checkCustomer(ev){
      window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: ev.status_message,
            type: ev.status_type,
            showCloseButton: true,
          });
          this.$root.$emit("bv::hide::modal", "availableinvoice");
    },
    recallRecord(){
       store
        .dispatch("retainer/fetchviewList", parseInt(this.$route.params.id));
    },
     async recordpayment(){
       await store.dispatch("retainer/fetchviewList", parseInt(this.$route.params.id))
        if(this.status_code!=404){
          this.$router.push({
            name : 'RetainerPaymentForm',
            params:{id:this.$route.params.id},
            query:{page:'retainerinvoice'}
          })
        }
    },
     async emailstatement() {
      await this.recallRecord();
      if (this.status_code != 404) {
        this.$router.push({
         name:'Email',query:{tns_type:'Customer Deposit',tns_date: this.list.header_details.retainer_date,cus_id:this.list.header_details.cus_id,cus_name:this.list.header_details.cus_name,
                tns_no:this.list.header_details.retainer_no,
                tns_mail:this.list.header_details.cus_mail,
                tns_currency:this.list.header_details.cus_currency,
                id:this.$route.params.id,date_format:this.org_details.date_format
          }
        });
      }
    },
  async recordrefund(){
       await this.recallRecord();
        if(this.status_code!=404){
          this.$router.push({
            name : 'RetainerInvoiceRefund',
            params:{id:this.$route.params.id},
            query:{page:'retainerinvoice'}
          })
        }
  },
    getTempProps(){
      this.field= this.$store.state.permission.print_settings_details["Customer Deposit"].template_list
    },
     async handlePrint() {
       await store
        .dispatch("retainer/fetchviewList", parseInt(this.$route.params.id));
        if(this.status_code==200){

       await this.getTempProps()
      document.title =
        this.list.header_details.retainer_no +
        " / " +
        this.getDateFormat(this.list.header_details.retainer_date);
      var id;
      var style;
      var size;
      if (this.retainer_settings_details.print.templateId == 26) {
        id =
          this.field.temp_prop.paper_size == 0
            ? this.field.temp_prop.orientation == 0
              ? "a4-standard-portrait-page"
              : "a4-standard-landscape-page"
            : this.field.temp_prop.paper_size == 1
            ? this.field.temp_prop.orientation == 0
              ? "a5-standard-portrait-page"
              : "a5-standard-landscape-page"
            : "";
        style = "standard";
        size =
          this.field.temp_prop.paper_size == 0
            ? this.field.temp_prop.orientation == 0
              ? "size:A4;"
              : "size:A4 landscape;"
            : this.field.temp_prop.paper_size == 1
            ? this.field.temp_prop.orientation == 0
              ? "size:A5;"
              : "size:A5 landscape;"
            : "";
      }
      var win;
      const element = document.getElementById(id);

      var printcontent = "";
      for (
        var i = 1;
        i <= this.general_settings_details.preferences.default_print_preference;
        i++
      ) {
        this.showprintlabel = await true;
        this.printlabel = await this.general_settings_details.preferences
          .document_copy_label[i];
        printcontent +=
          (await ' <div style="page-break-after:always">') +
          element.innerHTML +
          "</div>";
      }

      win = window.open(
        "",
        "Title",
        "fullscreen=yes",
        "titlebar=yes",
        "scrollbars=yes"
      );
      win.document.write(`
            <html>
              <head>
                <title>${document.title}</title>
                 <style>
                @page{
               ${size}
                margin:0 !important;
                }
                </style>
                <link rel="stylesheet" href="${process.env.VUE_APP_INVOICE_API_URL}/css/print/${style}.css">
              </head>
              <body class="${id}">
              ${printcontent}
              </body>
            </html>
          `);

      if (navigator.userAgent.indexOf("Safari") != -1) {
        setTimeout(() => {
          win.document.close();
          this.printlabel = "";
          this.showprintlabel = false;
          win.focus();
          win.print();
        }, 500);
        setTimeout(() => {
          win.close();
        }, 5000);
      } else {
        setTimeout(() => {
          win.document.close();
          this.printlabel = "";
          this.showprintlabel = false;
          win.focus();
          win.print();
          win.close();
        }, 500);
      }
        }
    },
    // call avialbel modal
    async callavailableinvoicemodal() {
        await store.dispatch("general/availableretainerinvoice",JSON.stringify({ id: this.$route.params.id })) .then((response)=>{
          if(response.data.code!=200){
              window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message:response.data.status,
              type: response.data.type,
              showCloseButton: true
            });
          }
        
    
        else{
      this.retainerDetails = {
        id: this.list.header_details.cus_id,
        unused_amount: this.list.header_details.available_amount,
        apply_unused_amount: this.list.header_details.available_amount
      };
      this.$root.$emit("bv::show::modal", "availableinvoice");
      EventBus.$emit("invoicedetails");
        }
        })
    },
      //Customize overlay for Print
    async showFullLayout() {
      await store
        .dispatch("settings/fetchinvoicesettings", {
          stg_menu: "Customer Deposit"
        })
        .then(() => {
          this.show_full_layout = true;
        });
    },
    // delete the selected recorc credti applied
    deleterefund(index) {
      this.$root.$emit("bv::show::modal", "deleterefundpayment");
      this.RefundDeleteDetail = this.list.refund_payment_details[index];
      this.deletedrefundrecord = index;
    },
    // get the reason how to delete the payment
    deletepaymentreason(index) {
      this.list.invoice_details_payment[index].inv_pymnt_id;

      store
        .dispatch(
          "invoice/deletepaymentreason",
          JSON.stringify({
            id: this.list.invoice_details_payment[index].inv_pymnt_id
          })
        )
        .then(response => {
          if(response.code==200){
          this.$root.$emit("bv::show::modal", "paymentreason");
          this.PaymentDeleteDetail = this.list.invoice_details_payment[index];
          this.deletedpymntrecord = index;
          // this.$refs["paymentreason"].show();
          }else{
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: response.status,
            type: response.type,
            showCloseButton: true,
          });
          this.recallRecord()
        }
        });
    },
    handlingapprovingmodal(ev) {
      this.content = ev.content;
      this.module = ev.module;
      this.globalmodaldata = ev.data;
      this.title = ev.title;
      this.isRoute = ev.isRoute;
      this.RoutePlace = ev.RoutePlace;
      this.globalmodaltype = ev.type;
      this.route_history = ev.route_history || "";
      this.$root.$emit("bv::show::modal", "handlingapprovingmodal");
    },

    updateAmountDetails(event) {
      //  subtrach applied amount from used amount
      this.list.header_details.used_amount =
        parseFloat(this.list.header_details.used_amount) -
        parseFloat(event.PaymentDeleteDetail.retainer_applied_amount);
      // add applied amount to available amount
      this.list.header_details.available_amount =
        parseFloat(this.list.header_details.available_amount) +
        parseFloat(event.PaymentDeleteDetail.retainer_applied_amount);
      //  remove the record from list
      this.list.invoice_details_payment.splice(this.deletedpymntrecord, 1);
      // update retaiern status
      if (
        parseFloat(this.list.header_details.available_amount) ==
        parseFloat(this.list.header_details.received_amount)
      ) {
        this.list.header_details.retainer_status_id = 6;
      } else {
        this.list.header_details.retainer_status_id = 7;
      }
    },
    updateRefundAmountDetails(event) {
      //  subtrach applied amount from used amount
      this.list.header_details.refund_amount =
        parseFloat(this.list.header_details.refund_amount) -
        parseFloat(event.RefundDeleteDetail.retainer_applied_amount);
      // add applied amount to available amount
      this.list.header_details.available_amount =
        parseFloat(this.list.header_details.available_amount) +
        parseFloat(event.RefundDeleteDetail.retainer_applied_amount);
      //  remove the record from list
      this.list.refund_payment_details.splice(this.deletedrefundrecord, 1);
      // update retaiern status
      if (
        parseFloat(this.list.header_details.available_amount) ==
        parseFloat(this.list.header_details.received_amount)
      ) {
        this.list.header_details.retainer_status_id = 6;
      } else {
        this.list.header_details.retainer_status_id = 7;
      }
    },
    // handlePrint() {
    //   document.title =
    //     this.list.header_details.retainer_no +
    //     " / " +
    //     this.list.header_details.retainer_date;
      
    //   window.print();
    //   $(".wrap").css("margin-left", "");
    // },
    //  to get the json value
    getPresentValue(arr, prop, val, return_prop) {
      var hasMatch = "";
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][prop] == val) {
          hasMatch = arr[i][return_prop];
          break;
        }
      }
      return hasMatch;
    }
  },
  created() {
    this.getTempProps();
    this.mail_id = this.list.header_details.cus_mail;
    document.title = getPageTitle(
      this.list.header_details.retainer_no + " | " + this.$route.meta.title
    );
    this.currency_symbol = this.getDetails(
      this.$AppDetails.currency_details,
      this.list.header_details.cus_currency,
      "currency_symbol"
    );

    this.total_in_words =
      this.getDetails(
        this.$AppDetails.currency_details,
        this.list.header_details.cus_currency,
        "currency_code_number"
      ) +
      " " +
      // number_to_words(
      //   this.list.header_details.retainer_total,
      //   this.getDetails(
      //     this.$AppDetails.currency_details,
      //     this.list.header_details.cus_currency,
      //     "currency_code_fraction"
      //   )
      // );
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  computed: {
    ...mapState({
      list: state => state.retainer.list,
      status_code: state => state.retainer.status_code, 
      status_message: state => state.retainer.status_message, 
      status_type: state => state.retainer.status_type, 
     retainer_index_history: (state) => state.retainer.retainer_index_history
    }),
    ...mapGetters([
      "org_details",
      "retainer_settings_details",
      "orgCurrencySymbol",
      "general_settings_details"
    ])
  }
};
</script>
<style >
@media print {
  .wrap {
    margin-left: 0px !important;
  }
}
</style>
<style scoped>
.vr {
  border: thick solid rgb(190, 184, 184);
  border-width: 1px;
  height: 50px;
  margin-right: 6px;
}
</style>



